// extracted by mini-css-extract-plugin
var _1 = "EntityProfileHeaderTitle-moduleEntityProfileHeaderTitle__d7Zpi";
var _2 = "EntityProfileHeaderTitle-moduleopen__bqEaS";
var _3 = "EntityProfileHeaderTitle-moduletextContainer__dUKFd";
var _4 = "EntityProfileHeaderTitle-moduletitleItem__xEB0C";
export { _1 as "EntityProfileHeaderTitle", _2 as "open", _3 as "textContainer", _4 as "titleItem" }
